export enum ActionTypes {
  FETCH_COURSE_HAS_ENROLMENT_CONSENT_PERMISSION_START = 'FETCH_COURSE_HAS_ENROLMENT_CONSENT_PERMISSION_START',
  FETCH_COURSE_HAS_ENROLMENT_CONSENT_PERMISSION_SUCCESS = 'FETCH_COURSE_HAS_ENROLMENT_CONSENT_PERMISSION_SUCCESS',

  UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_START = 'UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_START',
  UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_SUCCESS = 'UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_SUCCESS',
  UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_FAILED = 'UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_FAILED',
}

export interface CourseFetchHasEnrolmentConsentPermissionStart {
  type: ActionTypes.FETCH_COURSE_HAS_ENROLMENT_CONSENT_PERMISSION_START;
}
export interface CourseFetchHasEnrolmentConsentPermissionSuccess {
  type: ActionTypes.FETCH_COURSE_HAS_ENROLMENT_CONSENT_PERMISSION_SUCCESS;
  hasEnrolmentConsentPermission: boolean;
}

export interface UpdateLearnerHasEnrolmentConsentPermissionStart {
  type: ActionTypes.UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_START;
}

export interface UpdateLearnerHasEnrolmentConsentPermissionSuccess {
  type: ActionTypes.UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_SUCCESS;
}
export interface UpdateLearnerHasEnrolmentConsentPermissionFailed {
  type: ActionTypes.UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_FAILED;
  error: string;
}

export type LearnersEmailConsentActions =
  | CourseFetchHasEnrolmentConsentPermissionStart
  | CourseFetchHasEnrolmentConsentPermissionSuccess
  | UpdateLearnerHasEnrolmentConsentPermissionStart
  | UpdateLearnerHasEnrolmentConsentPermissionSuccess
  | UpdateLearnerHasEnrolmentConsentPermissionFailed;
